import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";
import { isDemoMode, exitDemo } from "./demoStore";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = loading, false = anon
    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get("/auth/me");
                setUser(data);
            } catch {
                setUser(false);
            }
        })();
    }, []);
    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        if (data.token) localStorage.setItem("afo_token", data.token);
        setUser(data);
        return data;
    };
    const logout = async () => {
        if (isDemoMode()) {
            exitDemo();
            setUser(false);
            return;
        }
        try { await api.post("/auth/logout"); } catch { /* ignore */ }
        localStorage.removeItem("afo_token");
        setUser(false);
    };
    return (
        <AuthCtx.Provider value={{ user, login, logout, setUser }}>
            {children}
        </AuthCtx.Provider>
    );
}

export const useAuth = () => useContext(AuthCtx);
